import { render, staticRenderFns } from "./specialist.vue?vue&type=template&id=51ee7876"
import script from "./specialist.vue?vue&type=script&lang=js"
export * from "./specialist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports